<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="上级标签" prop="pid" >
        <a-tree-select
          v-model="form.pid"
          showSearch
          style="width: 300px"
          :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
          placeholder="请选择上级标签"
          allowClear
          treeDefaultExpandAll
          :disabled="disabled"
          treeNodeFilterProp="title"
          @change="onChangePid">
          <a-tree-select-node v-for="(oneTag,index) in oneTagList" :title="oneTag.name" :value="oneTag.id" :key="index" >
            <a-tree-select-node v-for="(twoTag,index) in oneTag.children" v-if="oneTag.children" :value="twoTag.id" :title="twoTag.name" :key="index">
            </a-tree-select-node>
          </a-tree-select-node>
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="标签名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="标签描述" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getIllnessTag, addIllnessTag, updateIllnessTag, queryMenuList } from '@/api/biz/illnessTag'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      oneTagList: [],
      disabled: false,
      // 表单参数
      form: {
        id: null,

        name: null,

        level: null,

        pid: null,

        pids: null,

        isEnable: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        pid: [
          { required: true, message: '上级标签不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '标签名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getOneTagList() {
      queryMenuList({}).then(response => {
        this.oneTagList = response.data
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.disabled = false
      this.form = {
        id: null,
        name: null,
        level: null,
        pid: null,
        pids: null,
        isEnable: null,
        createTime: null,
        remark: null
      }
      this.getOneTagList()
    },
    onChangePid(value) {
      this.form.pid = value
      this.form.level = 1
      this.oneTagList.forEach(i => {
        if (i.id === value) {
          this.form.level = i.level + 1
        }
        if (i.children && i.children.length) {
          i.children.forEach(j => {
            if (j.id === value) {
              this.form.level = j.level + 1
            }
          })
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      this.disabled = true
      const id = row ? row.id : ids
      getIllnessTag({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateIllnessTag(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addIllnessTag(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
